import { ShoppingCart, Check, Zap, Shield, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const DualServiceFeatures = () => {
  const refundFeatures = [
    "AI-Powered Refund Letters",
    "Multiple Professional Tones",
    "Platform Intelligence",
    "Escalation Support",
    "Response Management",
    "Success Tracking"
  ];

  const additionalFeatures = [
    "Fast Processing",
    "Secure & Private",
    "24/7 Access"
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white/40 to-white/50">
      <div className="container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Smart Refund Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Get professional, AI-powered refund letters that work. Our platform helps you recover money from online purchases with intelligent, persuasive communication.
          </p>
        </div>
        
        <div className="max-w-2xl mx-auto">
          {/* Main Refund Service */}
          <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-lg">
            <div className="flex items-center gap-3 mb-6">
              <ShoppingCart className="h-8 w-8 text-teal-600" />
              <h3 className="text-2xl font-bold text-gray-900">Online Shopping Refunds</h3>
            </div>
            
            <div className="grid md:grid-cols-2 gap-4 mb-8">
              <div className="space-y-3">
                {refundFeatures.slice(0, 3).map((feature, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <Check className="h-5 w-5 text-teal-500" />
                    <span className="text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>
              <div className="space-y-3">
                {refundFeatures.slice(3).map((feature, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <Check className="h-5 w-5 text-teal-500" />
                    <span className="text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="flex gap-4 justify-center mb-6">
              {additionalFeatures.map((feature, index) => {
                const icons = [Zap, Shield, Clock];
                const Icon = icons[index];
                return (
                  <div key={index} className="flex items-center gap-2 text-sm text-gray-600">
                    <Icon className="h-4 w-4 text-teal-500" />
                    <span>{feature}</span>
                  </div>
                );
              })}
            </div>
            
            <Button asChild className="w-full bg-teal-600 hover:bg-teal-700 h-12 text-lg">
              <Link to="/refund">Start Your Refund Request</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DualServiceFeatures;